import type { IComment } from '../../../api';
import { InlineEmojiPicker } from '../../InlineEmojiPicker/InlineEmojiPicker';
import { useCommentReaction } from './useCommentReaction';

export function CommentReactionButton({ comment }: { comment: IComment }) {
	const { handleSelectEmoji } = useCommentReaction({ comment });

	return <InlineEmojiPicker onClick={handleSelectEmoji} />;
}
